//@flow
import { asyncComponent } from 'react-async-component'
import LoadingComponent from '../../LoadingComponent'
import ErrorComponent from '../../ErrorComponent'

export default asyncComponent({
  resolve: () => import('./AudioButton'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncAudioButton',
})



// WEBPACK FOOTER //
// ./src/components/QuestionElements/AudioButton/index.js